import * as types from '@/store/mutation-types';
import _ from 'lodash';
import { searchParty } from '@/mixins/search-party';

const mutations = {
  [types.UPDATE_ALL_REFERENCES](state, { item, site, updates }) {
    // this will update all page references like queued and in type list
    const { type } = item;
    const list = `${type}s`;
    const listed = (site[list] || []).find(i => i._id === item._id);
    if (listed) {
      updates.forEach((update) => {
        listed[update.key] = update.value;
      });
    }
    updates.forEach((update) => {
      item[update.key] = update.value;
    });
  },
  [types.UNLINK_TEMPLATE](state, p) {
    const page = _.omit(p.tcb.currentPage, ['templateID']);

    // recursively search page / blocks / droplets etc.
    // for templateRegion prop and set to false;
    searchParty.methods._setAllProps({
      entry: page.blocks,
      key: 'templateRegion',
      newVal: false, // update prop with this value
      newId: true,
    }, p.collect);

    // of any image type droplets that may have been found and unlinked,
    // go grab all of their s3 sources so we can make copies
    searchParty.methods._findAllPropVals({
      entry: p.collect.list,
      key: 'src',
      exclude: new RegExp(/\/drz-assets\/mock-images\//, 'gi'),
    }, p.collect.sources);

    p.tcb.currentPage = page;
  },
  [types.INJECT_TEMPLATE](state, p) {
    const template = _.find(p.currentSite.templates, t => t._id === p.templateId);
    const allBlocks = template.blocks.concat(p.currentPage.blocks);
    p.currentPage.blocks = allBlocks;
    // NOTE smoke test that we don't need to bounce page due to dragula state
    p.currentPage.templateID = p.templateId;
  },
  [types.REMOVE_TEMPLATE](state, p) {
    p.currentPage.templateID = false;
    p.currentPage.blocks = _.filter(p.currentPage.blocks, block => !block.templateRegion);
  },
};

const actions = {
  injectTemplate({ commit }, p) {
    commit(types.INJECT_TEMPLATE, p);
  },
  removeTemplate({ commit }, p) {
    commit(types.REMOVE_TEMPLATE, p);
  },
  updateAllReferences({ commit, rootState }, p) {
    commit(types.UPDATE_ALL_REFERENCES, {
      ...p,
      site: rootState.Websites.currentSite,
    });
  },
  async unlinkTemplate({ commit, rootState }) {
    // we can use this to collect certain droplets that were unlinked. in this
    // situation, we need to see if there were any image type droplets that
    // were unlinked so we can go and create new s3 folders for them, thus
    // completely untying them to the template droplets
    const collect = {
      droplets: ['imageGallery', 'imageGeneral', 'carousel', 'contentSlider'],
      list: [],
      sources: [],
    };
    await commit(types.UNLINK_TEMPLATE, { tcb: rootState.TopControlBar, collect });
    return new Promise((resolve) => {
      resolve(collect.sources);
    });
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/page-settings/vuex.js